module.exports = __webpack_public_path__ + "img/ChaosKnight.bca40a93.png";